import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

//Componentes ==================================
import ModalReservation from "../../PaymentPost/ModalReservation";
//Icons ========================================
import logo from './icons/sp/icon-black.png'
import { IcoBell, IcoCalendar, IcoPlus, IcoCash, IcoMenu, IcoLogout } from '../components/icons/Icons';
//Api ===========================================
import { MachinesFetchAPI } from "../../../api/Machines";
import ErrorAlert from "../../Alerts/ErrorAlert";
//Styles ========================================
import './new/Header/Header.css';

export default function RfmHeaderMain({
  onOpenMenu,
  business_code,
  branchoffice_code,
  stats = { available: 0, occupied: 0, sales: 0 },
  onToggleSidebar = () => { },
  onOpenModal, // (name) => void  e.g. "reservation" | "merge-tables" | "create-table"
  tables = [],
  updateTable,
  pendingTableRequestsCount = 0,
  onOpenTableRequests,
}) {
  const navigate = useNavigate();
  const IcoX = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  );
  const [menuOpen, setMenuOpen] = useState(false);

  //Function to logout of the pos (releases the machine, same as /payments)
  const signout = async () => {
    let machine_token = localStorage.getItem('x-access-machine-token');
    let machine = JSON.parse(localStorage.getItem('machine_original'));

    if (!machine || !machine.code) {
      ErrorAlert("No se encontró información de la máquina", "No se puede cerrar sesión correctamente", "error");
      return;
    }

    let liberada = false;
    let errorMsg = '';
    try {
      const response = await MachinesFetchAPI.updateMachineStatus(machine.code, false, machine_token);
      if (response.data && response.data.success === true) {
        liberada = true;
      } else {
        errorMsg = response.data && response.data.error ? response.data.error : 'No se pudo liberar la máquina.';
      }
    } catch (err) {
      errorMsg = err?.response?.data?.error || err?.message || 'Error de red al liberar la máquina.';
    }

    if (liberada) {
      localStorage.clear();
      navigate(`/machines/login/${business_code}`);
    } else {
      ErrorAlert("No se pudo liberar la máquina", errorMsg + "\nIntente nuevamente. Si el problema persiste, contacte a soporte.", "error");
    }
  }

  /* ============================================================
   TopMenuDrawer — drawer de acciones para responsive.
   Se abre con el botón de menú del header (onOpenMenu).
   Reúne las MISMAS acciones del header. Prefijo spm-*.
   ============================================================ */
  function TopMenuDrawer({
    open,
    onClose,
    pendingTableRequestsCount = 0,
    onOpenTableRequests,
    onOpenModal,
    onGoToPayments,
    onSignOut,
  }) {
    return (
      <>
        <div className="spm-scrim" hidden={!open} onClick={onClose} aria-hidden="true" />

        <aside className={"spm-drawer" + (open ? " is-open" : "")}
          aria-hidden={!open} aria-label="Menú de acciones">

          <div className="spm-head">
            <div className="sp-top-left">
              <div className="sp-logo-top">
                {/* <div className="sp-logo-mark">SP</div> */}
                <img src={logo} alt="" className="sp-logo-mark" />
              </div>
              <div>
                <h1>Mesas</h1>
                {/* <p>{branch} · {date}</p> */}
              </div>
            </div>
            <button className="spm-close" type="button" onClick={onClose} aria-label="Cerrar menú">
              <IcoX />
            </button>
          </div>
          <div className="spm-head">
            <span className="spm-title">Acciones</span>
          </div>

          <div className="spm-actions">
            <button
              className="spm-action"
              onClick={() => { onClose(); onOpenTableRequests?.(); }}
            >
              <IcoBell />
              <span>Solicitudes de mesa</span>
              {pendingTableRequestsCount > 0 && (
                <span className="spm-count">{pendingTableRequestsCount > 99 ? "99+" : pendingTableRequestsCount}</span>
              )}
            </button>

            <button className="spm-action" onClick={() => { onClose(); onOpenModal?.("merge-tables"); }}>
              <i className="bi bi-link-45deg" />
              <span>Unir mesas</span>
            </button>

            <button className="spm-action" onClick={() => { onClose(); onOpenModal?.("create-table"); }}>
              <IcoPlus size={16} />
              <span>Nueva mesa</span>
            </button>

            <button className="spm-action" onClick={() => { onClose(); onOpenModal?.("reservation"); }}>
              <IcoCalendar size={16} />
              <span>Crear reserva</span>
            </button>

            <button className="spm-action accent" onClick={() => { onClose(); onGoToPayments?.(); }}>
              <IcoCash size={16} />
              <span>Caja de pago</span>
            </button>

            <button className="spm-action" onClick={() => { onClose(); onSignOut?.(); }}>
              <IcoLogout size={16} />
              <span>Cerrar sesión</span>
            </button>
          </div>
        </aside>
      </>
    );
  }






  return (
    <>



      <header className="sp-top">
        <div className="sp-top-left">
          <div className="sp-logo-top">
            {/* <div className="sp-logo-mark">SP</div> */}
            <img src={logo} alt="" className="sp-logo-mark" />
          </div>
          <div>
            <h1>Mesas</h1>
            {/* <p>{branch} · {date}</p> */}
          </div>
        </div>

        <div className="sp-top-actions">
          <button
            onClick={onOpenTableRequests}
            className={`sp-btn sp-btn-icon ${pendingTableRequestsCount > 0 ? "has-pending" : ""}`} aria-label="Solicitudes de mesa">
            <IcoBell />
            {pendingTableRequestsCount > 0 && <span className="sp-badge"> {pendingTableRequestsCount > 99 ? "99+" : pendingTableRequestsCount}</span>}
          </button>
          {/* =================================== */}



          {/* =================================== */}
          <ModalReservation business_code={business_code} branchoffice_code={branchoffice_code} tables={tables} updateTable={updateTable} />

          {/* =================================== */}
      {/*     <button
            className="sp-btn js-new-table"
            type="button"
            onClick={() => onOpenModal?.("merge-tables")}
          >
            <i className="bi bi-link-45deg" />
            Unir
          </button> */}
          {/* =================================== */}
          <button className="sp-btn js-new-table" onClick={() => onOpenModal?.("create-table")}>
            <IcoPlus size={15} /> Mesa
          </button>
          {/* =================================== */}
          <button className="sp-btn" onClick={() => onOpenModal?.("reservation")}>
            <IcoCalendar size={16} /> Crear reserva
          </button>
          {/* =================================== */}
          <button className="sp-btn sp-btn-accent" onClick={() => { navigate(`/payments/${business_code}/${branchoffice_code}`) }}>
            <IcoCash size={16} /> Caja de pago
          </button>
          {/* =================================== */}
          <button className="sp-btn sp-btn-icon" onClick={() => signout()} aria-label="Cerrar sesión" title="Cerrar sesión">
            <IcoLogout size={16} />
          </button>


          {/* =================================== */}
          <div className="d-flex d-md-flex d-lg-none d-md-xl-none gap-3">
            <button
              onClick={onOpenTableRequests}
              className={`sp-btn sp-btn-icon sp-menu-btn ${pendingTableRequestsCount > 0 ? "has-pending" : ""}`} aria-label="Solicitudes de mesa">
              <IcoBell />
              {pendingTableRequestsCount > 0 && <span className="sp-badge"> {pendingTableRequestsCount > 99 ? "99+" : pendingTableRequestsCount}</span>}
            </button>

            {/* =================================== */}

            <span className="sp-top-sep" aria-hidden="true" />
            <button
              className="sp-btn sp-btn-icon sp-menu-btn"
              aria-label="Abrir menú"
              onClick={() => setMenuOpen(true)}
            >
              <IcoMenu />
              {pendingTableRequestsCount > 0 && <span className="sp-badge">{pendingTableRequestsCount}</span>}
            </button>
          </div>
        </div>
      </header>

      <TopMenuDrawer
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        pendingTableRequestsCount={pendingTableRequestsCount}
        onOpenTableRequests={onOpenTableRequests}
        onOpenModal={onOpenModal}
        onGoToPayments={() => navigate(`/payments/${business_code}/${branchoffice_code}`)}
        onSignOut={() => signout()}
      />
    </>

  );
}
